import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationSetupService {

  constructor(
    private http: HttpClient,
  ) { }

  getEmployeeList(url: string, companyNo: number) {
    return this.http.get<any>(url + '/' + companyNo)
  }
  getNotificationSetup(url: string, locId: number[]) {
    return this.http.get<any>(url + "/" + locId)
  
  }
  saveNotification(url: string, obj: any) {
    return this.http.post<any>(
      url,obj,{ responseType: 'json' }
    );
  }

  getUserList(url: string) {
    return this.http.get(url);
  }

  getDynamicDataForMonitoringDashboard(url: string) {
    return this.http.get(url);
  }
}
